import React from "react";
import { observer } from "mobx-react";
import Button from "../Button";
import { validResult } from "./DilutionUtils";

function DilutionButton({ dilutionTests, onClick }) {
  const canSave = dilutionTests && dilutionTests.some((dt) => validResult(dt));
  return <Button primary title="Save Results" onClick={onClick} disabled={!canSave} small />;
}

export default observer(DilutionButton);
